@let count = review.openCount();
<div class="flex flex-col gap-2.5 p-3 rounded-lg border border-gray-200 bg-gray-50"
     data-proposal-review-bar="true">
  <div class="flex flex-row items-center gap-2">
    <fa-icon [icon]="faChatbicAi" class="text-green-500 text-xl shrink-0"></fa-icon>
    <span class="text-sm font-medium text-gray-900 flex-1 min-w-0"
          data-proposal-review-count="true">{{ count }} {{ count === 1 ? 'Änderung' : 'Änderungen' }} ausstehend</span>
    <div class="flex flex-row items-center gap-0.5 shrink-0">
      <!-- Tooltip am Wrapper: bic-button rendert sein `title` nicht. -->
      <span class="inline-flex" data-proposal-review-prev="true" tooltip="Vorherige Änderung" tooltipDirection="top">
        <bic-button (onClick)="review.prev()" [iconOnly]="true" ariaLabel="Vorherige Änderung" buttonType="no-border">
          <fa-icon [icon]="faChevronLeft" class="text-gray-900"></fa-icon>
        </bic-button>
      </span>
      <span class="text-xs font-medium text-gray-900 tabular-nums"
            data-proposal-review-position="true">{{ review.position() }} / {{ count }}</span>
      <span class="inline-flex" data-proposal-review-next="true" tooltip="Nächste Änderung" tooltipDirection="top">
        <bic-button (onClick)="review.next()" [iconOnly]="true" ariaLabel="Nächste Änderung" buttonType="no-border">
          <fa-icon [icon]="faChevronRight" class="text-gray-900"></fa-icon>
        </bic-button>
      </span>
    </div>
  </div>
  @if (review.stale()) {
    <div class="flex items-start gap-2" data-proposal-review-stale="true">
      <fa-icon [icon]="faTriangleExclamation" class="text-yellow-700 text-sm shrink-0 mt-0.5"></fa-icon>
      <span class="text-sm font-medium text-yellow-900">
        Der myCheck wurde seitdem bereits gespeichert – dieser Vorschlag basiert nicht mehr auf dem aktuellen Stand.
      </span>
    </div>
  }
  <!-- Beide Buttons teilen sich die Breite (Figma); reicht sie für die Beschriftung nicht (schmales Panel),
       rutscht „Alle übernehmen“ in eine eigene Zeile, statt über den Rand zu laufen: bic-button setzt seinen
       Text `whitespace-nowrap`, mit `min-w-0` lief der Inhalt über den Button hinaus. -->
  <div class="flex flex-row flex-wrap gap-2" data-proposal-review-actions="true">
    <bic-button (onClick)="review.discardAll()" [disabled]="review.busy()" [fullWidth]="true" buttonType="white"
                class="flex-1 min-w-fit">
      Alle verwerfen
    </bic-button>
    <bic-button (onClick)="review.acceptAll()" [disabled]="review.busy()" [fullWidth]="true" buttonType="primary"
                class="flex-1 min-w-fit">
      <fa-icon [icon]="faCheck" iconLeft></fa-icon>
      Alle übernehmen
    </bic-button>
  </div>
</div>
